/*
  +--------------------------------------------------------------------------------------
  | @Author:    chris<jiangqingqing@frippler.com>
  | @Title:     设备分享 API 接口
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function equipShareApi(data) {
  return request({
    url: '?c=rms&a=share&do=post',
    method: 'post',
    data: data
  })
}
